"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledProgressBar = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const ProgressBar_1 = require("./designTokens/ProgressBar");
const translate = (0, styled_components_1.keyframes) `
    0% {
        left: 0;
        right: 99%;
        transform: translateX(0)
    }

    50% {
        left: 0;
        right: 25%;
    }

    100% {
        left: 99%;
        right: 0;
        transform: translateX(25%)
    }
`;
exports.StyledProgressBar = styled_components_1.default.div `
    height: ${ProgressBar_1.progressBarTokens.progressBarHeight.getVar()};
    position: relative;
    overflow: hidden;

    &:before {
        content: '';

        position: absolute;
        left: 0;
        right: 0;

        top: 0;
        bottom: 0;
        background-color: ${ProgressBar_1.progressBarTokens.progressBarBackgroundColor.getVar()};

        animation: ${translate} 1s ease-out infinite;
    }
`;
//# sourceMappingURL=ProgressBar.styles.js.map